import React from 'react';
import fr from 'facet-rest';
import {
  FDPaper, FDStack, FDAccordionGroup, FDAccordion, FDAccordionTitle, FDAccordionDetails, FDIcon, FDLabelText, FDTitleText, FDSteppedProgress,
} from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';


const Tasks = ({ resource }) => {
  const { loadModalCollectionByLink } = useModalContext();

  const tasks = resource.attr('tasks').resources().list();
  if (!tasks || !tasks.length) {
    return (
      <FDLabelText value={'No tasks'} />
    );
  }

  const labels = tasks.map((task) => {
    const hasStartRelationship = task.withRelationship(fr.relationships.start.name, () => true, () => false);
    let onClick;
    if (hasStartRelationship) {
      onClick = () => loadModalCollectionByLink(task.relationship(fr.relationships.start.name).link('related').url());
    }

    let disabled = false;
    // If this task isn't active, disabled
    if (task.attr('active') === 'false') {
      disabled = true;
    }

    // But, if this task was already complete, you should be able to get back in
    if (task.attr('isComplete') === 'true') {
      disabled = false;
    }

    // Without a start relationship to navigate too, definitely disabled
    if (!hasStartRelationship) {
      disabled = true;
    }

    return {
      value: task.attr('title'),
      optional: task.attr('subtitle'),
      disabled,
      onClick,
    };
  });

  const completeTasks = tasks.filter(t => t.attr('isComplete') === 'true');

  return (
    <FDSteppedProgress orientation={'vertical'} steps={labels.length} value={completeTasks.length} labels={labels} />
  );
};

export const JourneyWidget = ({ collection }) => {
  if (!collection || !collection.resources() || !collection.resources().list().length) return null;

  return (
    <FDPaper appearance="flat" flex={1}>
      <FDAccordionGroup spacing={1} atLeastOneExpanded>
        {collection.resources().list().map((resource, i) => {
          const isActive = resource.isTruthy('active');
          const isCompleted = resource.isTruthy('isCompleted');
          return (
            <FDAccordion expansionID={resource.id()} expanded={isActive}>
              <FDAccordionTitle>
                <FDStack spacing={2} alignItems={'flex-start'}>
                  <FDIcon
                    icon={i < 3 ? `circle${i + 1}` : 'circle'}
                    color={isActive || isCompleted ? 'textSecondary' : 'textDisabled'}
                  />
                  <FDStack direction={'column'}>
                    <FDTitleText size="lg" value={resource.attr('title')} />
                    <FDLabelText
                      size="sm"
                      value={resource.attr('subtitle')}
                      color={isActive ? 'textSecondary' : 'textDisabled'}
                    />
                  </FDStack>
                </FDStack>
              </FDAccordionTitle>
              <FDAccordionDetails>
                <Tasks resource={resource} />
              </FDAccordionDetails>
            </FDAccordion>
          );
        })}
      </FDAccordionGroup>
    </FDPaper>
  );
};
